import { render, staticRenderFns } from "./SwipeTut.vue?vue&type=template&id=c4def77a&"
import script from "./SwipeTut.vue?vue&type=script&lang=js&"
export * from "./SwipeTut.vue?vue&type=script&lang=js&"
import style0 from "./SwipeTut.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports